<template>
  <div class="ocr-sk-block" :class="{ 'ocr-sk-block--round': round }" :style="blockStyle" />
</template>

<script>
export default {
  name: "OcrSkBlock",
  props: {
    height: { type: String, default: "220px" },
    minHeight: { type: String, default: "" },
    round: { type: Boolean, default: true },
  },
  computed: {
    blockStyle() {
      const style = { height: this.height };
      if (this.minHeight) style.minHeight = this.minHeight;
      return style;
    },
  },
};
</script>
